import React, { useState, useEffect, useRef } from 'react';
import './Carousel.css';

const cards = [
    {
        key: 'organizacion',
        image: '/assets/organizacion.webp',
        title: 'ORGANIZACIÓN Y AUTOMATIZACIÓN DE CRMs',
        subtitle: 'Automatizamos tus procesos internos y CRM para maximizar la retención de clientes e impulsar tus ventas'
    },
    {
        key: 'atencioncliente',
        image: '/assets/atencion-al-cliente.webp',
        title: 'SERVICIO AL CLIENTE INTELIGENTE',
        subtitle: 'Automatiza tu servicio 24/7 con bots inteligentes, gestión de citas y soporte multicanal de alta eficiencia '
    },
    {
        key: 'analisisdedatos',
        image: '/assets/analisis-de-datos.webp',
        title: 'ANÁLISIS DE DATOS',
        subtitle: 'Procesamiento de datos con herramientas de científicos e ingenieros de datos'
    },
    {
        key: 'solucionespersonalizadas',
        image: '/assets/soluciones.webp',
        title: 'SERVICIOS A MEDIDA',
        subtitle: 'Hallamos la solución que necesitas según tus necesidades'
    }
];

const Carousel = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const intervalRef = useRef(null);
    const total = cards.length;

    const resetAutoSlide = () => {
        clearInterval(intervalRef.current);
        intervalRef.current = setInterval(() => {
            setCurrentIndex(prev => (prev + 1) % total);
        }, 4000);
    };

    const prevSlide = () => {
        setCurrentIndex(prev => (prev - 1 + total) % total);
        resetAutoSlide();
    };

    const nextSlide = () => {
        setCurrentIndex(prev => (prev + 1) % total);
        resetAutoSlide();
    };

    useEffect(() => {
        resetAutoSlide();
        return () => clearInterval(intervalRef.current);
    }, []);

    const getVisibleSlides = () => {
        const prevIndex = (currentIndex - 1 + total) % total;
        const nextIndex = (currentIndex + 1) % total;

        return [
            { ...cards[prevIndex], position: 'prev' },
            { ...cards[currentIndex], position: 'active' },
            { ...cards[nextIndex], position: 'next' },
        ];
    };

    return (
        <section className="servicios-section" id="servicios">
            <div className="container">
                {/* --- NUEVO ENCABEZADO --- */}
                <div className="servicios-header">
                    <div className="eyebrow rv in">Nuestros Servicios</div>
                    <h2 className="s-title rv in">Soluciones para tu negocio</h2>
                </div>

                {/* --- CARRUSEL INTACTO EN LÓGICA --- */}
                <div className="carousel">
                    <button className="carousel-btn prev" onClick={prevSlide}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                    </button>

                    <div className="carousel-cards">
                        {getVisibleSlides().map(card => (
                            <a
                                key={card.key}
                                href={`/${card.key}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={`carousel-card ${card.position}`}
                            >
                                <div className="card-img-wrapper">
                                    <img src={card.image} alt={card.title} loading="lazy" />
                                </div>
                                <div className="card-content">
                                    <h3>{card.title}</h3>
                                    <h4>{card.subtitle}</h4>
                                    <span className="read-more">
                                        Saber más
                                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" style={{marginLeft: '4px'}}><path d="M2 7h10M7 2l5 5-5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
                                    </span>
                                </div>
                            </a>
                        ))}
                    </div>

                    <button className="carousel-btn next" onClick={nextSlide}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                    </button>
                </div>
            </div>
        </section>
    );
};

export default Carousel;